import React from 'react';
import classNames from 'classnames';
import styles from './TextLink.scss';

export default function TextLink({
  className,
  renderAs,
  inverted,
  disabled,
  children,
  ...props
}) {
  let Element = renderAs || 'a';
  return (
    <Element
      className={classNames(
        styles.link,
        inverted && styles.inverted,
        disabled && styles.disabled,
        className,
      )}
      disabled={disabled}
      {...props}
    >
      {children}
    </Element>
  );
}
